import { KbColor } from '@kb3d/models/classes/primitives/kb-color';
import { Kb3dModel } from '../decorators/kb3d-decorator';
import { ITextTextureLayer } from '../kb3d-models';
import { Token } from '../token';
import { TextureLayer } from './texture-layer';

@Kb3dModel<TextTextureLayer>({
    token: Token.TextTextureLayer,
})
export class TextTextureLayer extends TextureLayer implements ITextTextureLayer {
    color: KbColor;
    font: string;
    text: string;
}
